import { useState } from "react";
import { createPortal } from "react-dom";
import { Button } from "../../elements/Button";
import buttoncss from "../../css/button.module.css";
import icrCss from "../../css/interCompanyEliminations.module.css";
import { ReactComponent as PlusPrimary } from "../../assets/icons/primary_plus.svg"
import { ReactComponent as PlusWhite } from "../../assets/icons/whitePlus.svg"
import { ReactComponent as LeftArrowIcon } from "../../assets/icons/left_arrow.svg"
import { ReactComponent as DotIcon } from "../../assets/icons/dot.svg"
import { ReactComponent as FilterIcon } from "../../assets/icons/filter.svg"
import DifferenceRemarksModal from "./DifferenceRemarksModal";
import FilterModal from "./FilterModal";


export const companyComparisons = [
	{
		companyA: "Company A",
		companyA_id: 1,
		companyB: "Company B",
		companyB_id: 2,
		comparisonData: [
			{
				section: "Revenue",
				companyA: [{ particular: "Revenue", amount: 1000 }],
				companyB: [
					{ particular: "Purchases", amount: 800 },
					{ particular: "Consumption Expenses", amount: 200 }
				],
				difference: 0
			},
			{
				section: "Purchases",
				companyA: [
					{ particular: "Purchases", amount: 300 },
					{ particular: "Consumption Expenses", amount: 700 }
				],
				companyB: [{ particular: "Revenue", amount: 1000 }],
				difference: 500,
				remarks: "Difference caused by reclassification in Company B"
			},
			{
				section: "Other Income",
				companyA: [
					{ particular: "Other Income", amount: 800 },
					{ particular: "Finance Cost", amount: 200 }
				],
				companyB: [
					{ particular: "Other Income", amount: 800 },
					{ particular: "Finance Cost", amount: 200 }
				],
				difference: 300
			},
			{
				section: "Receivables & Payables",
				companyA: [
					{ particular: "Receivables", amount: null },
					{ particular: "Payables", amount: null }
				],
				companyB: [
					{ particular: "Receivables", amount: null },
					{ particular: "Payables", amount: null }
				],
				difference: null
			}
		],
		balances: {
			totalCompanyA: 3000,
			totalCompanyB: 3200,
			consolidatedBalance: 6200
		}
	},

	// 🟩 SECOND DATASET
	{
		companyA: "Alpha Pvt Ltd",
		companyA_id: 3,
		companyB: "Beta Corp",
		companyB_id: 4,
		comparisonData: [
			{
				section: "Sales",
				companyA: [{ particular: "Sales Income", amount: 5200 }],
				companyB: [{ particular: "Sales Income", amount: 5000 }],
				difference: 200,
				remarks: "Minor sales adjustment pending invoice verification"
			},
			{
				section: "Operating Expenses",
				companyA: [
					{ particular: "Salaries", amount: 1500 },
					{ particular: "Rent", amount: 700 }
				],
				companyB: [
					{ particular: "Salaries", amount: 1400 },
					{ particular: "Rent", amount: 700 }
				],
				difference: 100
			},
			{
				section: "Depreciation",
				companyA: [{ particular: "Depreciation Expense", amount: 400 }],
				companyB: [{ particular: "Depreciation Expense", amount: 400 }],
				difference: 0
			},
			{
				section: "Other Expenses",
				companyA: [
					{ particular: "Travel", amount: 300 },
					{ particular: "Communication", amount: 200 }
				],
				companyB: [
					{ particular: "Travel", amount: 250 },
					{ particular: "Communication", amount: 200 }
				],
				difference: 50
			}
		],
		balances: {
			totalCompanyA: 7600,
			totalCompanyB: 7500,
			consolidatedBalance: 15100
		}
	},

	// 🟦 THIRD DATASET
	{
		companyA: "Zenith Solutions",
		companyA_id: 5,
		companyB: "Orion Industries",
		companyB_id: 6,
		comparisonData: [
			{
				section: "Service Income",
				companyA: [{ particular: "Consulting Revenue", amount: 4200 }],
				companyB: [{ particular: "Consulting Revenue", amount: 4000 }],
				difference: 200
			},
			{
				section: "Cost of Services",
				companyA: [
					{ particular: "Subcontracting", amount: 1000 },
					{ particular: "Software Licenses", amount: 600 }
				],
				companyB: [
					{ particular: "Subcontracting", amount: 1200 },
					{ particular: "Software Licenses", amount: 600 }
				],
				difference: 200,
				remarks: "Vendor invoice for subcontracting pending in Company A"
			},
			{
				section: "Administrative Expenses",
				companyA: [
					{ particular: "Office Supplies", amount: 150 },
					{ particular: "Utilities", amount: 100 }
				],
				companyB: [
					{ particular: "Office Supplies", amount: 180 },
					{ particular: "Utilities", amount: 100 }
				],
				difference: 30
			},
			{
				section: "Interest Income",
				companyA: [{ particular: "Interest Income", amount: 200 }],
				companyB: [{ particular: "Interest Income", amount: 200 }],
				difference: 0
			}
		],
		balances: {
			totalCompanyA: 6150,
			totalCompanyB: 6280,
			consolidatedBalance: 12430
		}
	}
];

export const filterOptions = [
	{
		"name": "My User",
		"type": "people",
		"fieldType": "Custom",
		"key": "68da6c4a4b78aec1ee742624",
		"filterTypes": [
			"include",
			"exclude"
		]
	},
	{
		"name": "My Tags",
		"type": "tag",
		"fieldType": "Custom",
		"key": "68db6813d3413bfab6cfb00f",
		"filterTypes": [
			"contains",
			"starts with",
			"does not contain"
		]
	},
	{
		"name": "Assignee",
		"type": "people",
		"fieldType": "Default",
		"key": "assigneeIDs",
		"filterTypes": [
			"include",
			"exclude"
		]
	},
	{
		"name": "Approver",
		"type": "people",
		"fieldType": "Default",
		"key": "approverID",
		"filterTypes": [
			"include",
			"exclude"
		]
	},
	{
		"name": "Module",
		"type": "shortText",
		"fieldType": "Default",
		"key": "module",
		"filterTypes": [
			"contains",
			"starts with",
			"does not contain"
		]
	},
	{
		"name": "Due Date",
		"type": "date",
		"fieldType": "Default",
		"key": "dueDate",
		"filterTypes": [
			"less than",
			"equal to",
			"greater than"
		]
	},
	{
		"name": "Status",
		"type": "shortText",
		"fieldType": "Default",
		"key": "status",
		"filterTypes": [
			"contains",
			"starts with",
			"does not contain"
		]
	}
]


const PerformReconciliation = ({ setEliminationScreen }) => {

	const [activePopover, setActivePopover] = useState(null);
	const [popoverPos, setPopoverPos] = useState({ x: 0, y: 0 });

	const [remarksModalOpen, setRemarksModalOpen] = useState(false)
	const [remarksModalType, setRemarksModalType] = useState(null);
	const [selectedRemarkData, setSelectedRemarkData] = useState(null);

	const [filterModalOpen, setFilterModalOpen] = useState(false)


	const togglePopover = (index, e) => {
		if (activePopover === index) {
			setActivePopover(null);
		} else {
			const rect = e.target.getBoundingClientRect();
			setPopoverPos({ x: rect.right, y: rect.bottom });
			setActivePopover(index);
		}
	};

	const handleRemarksModalClose = () => {
		setRemarksModalOpen(false);
		setRemarksModalType(null);
		setSelectedRemarkData(null);
	};

	const handleRemarksClick = (row) => {
		if (row.remarks) {
			setRemarksModalType("view");
		} else {
			setRemarksModalType("add");
		}
		setSelectedRemarkData(row);
		setRemarksModalOpen(true);
	};

	const handleFilterModalClose = () => {
		setFilterModalOpen(false)
	}

	return (
		<>
			<div className={icrCss.header}>
				<div style={{ display: "flex", alignItems: "center", gap: "15px", fontSize: "14px" }}>
					<span style={{ cursor: "pointer" }} onClick={() => setEliminationScreen(0)}>
						<span>
							<LeftArrowIcon height={12} style={{ marginBottom: "2px" }} />
						</span>
						<span style={{ color: "#4D6D64", marginLeft: "10px" }}>
							Inter company elimination
						</span>
					</span>
					<span>
						<DotIcon />
					</span>
					<span style={{ color: "#4D6D64", cursor: "pointer" }} onClick={() => setEliminationScreen(1)}>View workings</span>
					<span>
						<DotIcon />
					</span>
					<span>Perform reconciliation</span>
				</div>

				<div style={{ display: "flex", alignItems: "center", gap: "15px", fontSize: "10px" }}>

					<div className={icrCss.performReconciliationFilterCtn}>
						<div className={icrCss.filterItemBadge}>
							<span>Identifier - relative -</span>
							<span>value</span>
						</div>
						<div className={icrCss.filterItemBadge}>
							<span>Identifier - relative -</span>
							<span>value</span>
						</div>
						<div className={icrCss.filterItemBadge}>
							<span>Identifier - relative -</span>
							<span>value</span>
						</div>
						<div className={icrCss.filterItemBadge}>
							<span>Identifier - relative -</span>
							<span>value</span>
						</div>
					</div>

					<FilterIcon style={{ cursor:"pointer" }} onClick={() => setFilterModalOpen(true)} />

					<Button
						icon={<PlusWhite />}
						btnColor={buttoncss.primary}
						label="Add Entry"
					/>
				</div>
			</div>
			<div className={icrCss.comparisonGrid}>
				{companyComparisons.map((block, index) => (
					<div key={index} className={icrCss.comparisonCard}>
						<div className={icrCss.comparisonCardHeader}>
							<span>{block.companyA} - {block.companyB}</span>
							<Button
								class_={icrCss.comparisonCardHeaderBtn}
								btnColor={buttoncss.primary}
								label="Export"
							/>
						</div>
						<div className={icrCss.comparisonTableWrapper}>
							<table className={icrCss.comparisonTable}>
								<thead>
									<tr>
										<th>{block.companyA}</th>
										<th>{block.companyB}</th>
										<th>Difference</th>
									</tr>
								</thead>
								<tbody>
									{block.comparisonData.map((row, i) => (
										<tr key={i}>
											<td>
												{row.companyA.map((item, j) => (
													<div key={j} className={icrCss.comparisionTableRowItem}>
														<span className={icrCss.particular}>{item.particular}</span>
														<span className={icrCss.amount}>{item.amount ?? ""}</span>
													</div>
												))}
											</td>
											<td>
												{row.companyB.map((item, j) => (
													<div key={j} className={icrCss.comparisionTableRowItem}>
														<span className={icrCss.particular}>{item.particular}</span>
														<span className={icrCss.amount}>{item.amount ?? ""}</span>
													</div>
												))}

											</td>
											<td
												className={`${row.difference ? icrCss.differenceCell : icrCss.differenceDefaultCell}`}
												onClick={(e) => togglePopover(i, e)}
											>
												{row.difference !== null ? row.difference : ""}

												{activePopover === i &&
													createPortal(
														<div
															className={icrCss.popover}
															style={{
																position: "absolute",
																top: popoverPos.y - 10,
																left: popoverPos.x - 180,
															}}
														>
															<Button
																btnColor={buttoncss.primary}
																label="View Reconciliation"
																onClick={() => setEliminationScreen(3)}
															/>

															{row.remarks ? (
																<Button
																	btnColor={buttoncss.secondary}
																	label="View Remarks"
																	onClick={() => handleRemarksClick(row)}
																/>
															) : (
																<Button
																	icon={<PlusPrimary />}
																	btnColor={buttoncss.secondary}
																	label="Add Remarks"
																	onClick={() => handleRemarksClick(row)}
																/>
															)}
														</div>,
														document.body
													)}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
				))}

			</div>
			{remarksModalOpen && (
				<DifferenceRemarksModal
					handleClose={handleRemarksModalClose}
					type={remarksModalType}
					data={selectedRemarkData}
				/>
			)}

			{filterModalOpen && (
				<FilterModal 
					filterAttr={filterOptions}
					handleClose={handleFilterModalClose}
				/>
			)}

		</>
	)

}


export default PerformReconciliation;